import { ScoopCenter } from '../../../../ui'
import { EmptyDataset } from '../../../../EmptyDataset/EmptyDataset'
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react'
import styles from './ProcessNoDatasetFound.module.scss'

export const ProcessNoDatasetFound = () => {
    return (
        <ScoopCenter className={styles.container}>
            <EmptyDataset
                title="No snapshot data available"
                description="Process Analysis requires datasets that track state changes over time, such as CRM opportunities, support tickets, or subscription statuses."
                iconComponent={
                    <ClockCounterClockwiseIcon size={80} weight="regular" className={styles.icon} />
                }
                hideButton={true}
            />
        </ScoopCenter>
    )
}
